import styled from 'styled-components';
import { StandardText } from '../StandardText/StandardText';

export const DisclaimerText = styled(StandardText)`
  color: #4d4d4d;
  font-size: 0.8rem;
`;
